<template>
  <div class="collection"
    :style="pageId && pageStyle">
    <CollectionNav v-if="!showCover"
      :locale="locale"
      :lang="lang"
      :pageId="pageId"
      :categoryId="categoryId"
      :useCollectionPage="useCollectionPage"
      :isMainPage="isMainPage" />
    <router-view v-if="getPageSetting && getMainPage"
      class="collectionContent"
      :locale="locale"
      :lang="lang"
      :pageId="pageId"
      :categoryId="categoryId"
      :isMainPage="isMainPage"
      :isCollectableUser="getCollectable.isCollectableUser"
      @hideCover="hideCover">
    </router-view>
    <MegaMenu
      v-if="isMegaMenu"
      class="collectionContent"
      :locale="locale"
      :lang="lang"
      :pageId="pageId" />
    <DetailGallery
      v-if="detailGallery"
      :locale="locale"
      :lang="lang"
      :pageId="pageId"
      :categoryId="categoryId"
      :isCollectableUser="getCollectable.isCollectableUser" />
    <DetailVideo
      v-if="detailVideo"
      :locale="locale"
      :lang="lang"
      :pageId="pageId"
      :categoryId="categoryId" />
    <!-- <ToastMessage
      v-if="toastMessage"
      :locale="locale"
      :message="toastMessage"
      @close="setToastMessage(null)" /> -->
  </div>
</template>

<script>
import '@/assets/css/collection.scss'
import ToastMessage from '@/components/Util/ToastMessage'
import MegaMenu from '@/components/Collection/MegaMenu'
import Cover from '@/components/Collection/Cover'
import CollectionNav from '@/components/Collection/Nav'
import DetailGallery from '@/components/Collection/DetailGallery'
import DetailVideo from '@/components/Collection/DetailVideo'

export default {
  name: 'Collection',
  props: [
    'locale',
    'lang',
    'responsive',
    'pageId',
    'categoryId'
  ],
  components: {
    ToastMessage,
    MegaMenu,
    Cover,
    CollectionNav,
    DetailGallery,
    DetailVideo
  },
  computed: {
    isMegaMenu () {
      return this.$store.getters['collection/getMegaMenu']
    },
    // toastMessage () {
    //   return this.$store.getters['collection/getToastMessage']
    // },
    isMainPage () {
      return this.$route.name === 'collectionIntro' || this.$route.name === 'collectionCover'
    },
    useCollectionPage () {
      return this.$store.getters['collection/useCollectionPage']
    },
    getPageSetting () {
      return this.$store.getters['collection/getCollectionSetting']
    },
    getMainPage () {
      return this.$store.getters['collection/getCollectionMainPage']
    },
    getMyCollectionSetting () {
      return this.$store.getters['collection/getMyCollectionSetting']
    },
    isMyCollection () {
      return this.$route.name === 'myCollection'
    },
    pageStyle () {
      const isMyCollection = this.isMyCollection
      const setting = this.getPageSetting
      const myCollectionSetting = this.getMyCollectionSetting
      function spacingToLts (spacing) {
        const numeric = parseFloat(spacing)
        if (isNaN(numeric)) return null // 유효하지 않은 입력 처리
        return (numeric / 1000).toFixed(2)
      }
      return setting && {
        backgroundColor: isMyCollection ? myCollectionSetting.backgroundColor : setting.backgroundColor,
        color: setting.fontColor,
        fontSize: `${setting.fontSize}px`,
        letterSpacing: `${spacingToLts(setting.spacing)}em`,
      }
    },
    detailGallery () {
      return this.$store.getters['collection/getDetailGallery']
    },
    detailVideo () {
      return this.$store.getters['collection/getDetailVideo']
    },
    getCollectable () {
      const authInfo = this.$store.getters['authentication/getAuthInfo']
      const getPageIdByOta = this.$store.getters['collection/getPageIdByOta']
      const isEqualPageId = this.pageId === getPageIdByOta
      const isExpired = authInfo.otavalid === 'false'
      const isStaff = authInfo.staff
      return {
        isCollectablePageId: isEqualPageId, // 콜렉션 이용 가능한 spaceid인가?
        isStaff: isStaff ? `${authInfo.staff}.${authInfo.site}` : false,
        isExpired: isExpired,
        isCollectableUser: isEqualPageId && (isStaff || !isExpired)
      }
    }
  },
  watch: {
    '$route' (to, from, next) {
      this.$store.commit('collection/setMegaMenu', false)
      if (!from.params.pageId && to.params.pageId) {
        this.init()
      }
    }
  },
  async created () {
    // spaceid가 콜렉션 가능한 pageId
    const getSpacePageId = await this.getCollectionPageId()
    if (this.pageId) {
      this.init()
    } else {
      if (getSpacePageId) {
        this.$router.replace({
          name: 'collectionPageDefault',
          params: {
            ...this.$route.params,
            pageId: getSpacePageId
          }
        })
      } else {
        this.$router.replace('/')
      }
    }
  },
  data () {
    return {
      showCover: false,
      category: null,
      list: null
    }
  },
  methods: {
    async init () {
      await this.getCollectionPageProperty()
      if (this.$router.name === 'collectionCover') {
        this.showCover = true
      }
    },
    hideCover () {
      this.showCover = false
      this.$router.push({
        name: this.getMainPage && this.getMainPage.intro ? 'collectionIntro' : 'collectionMain',
        params: {
          ...this.$route.params
        }
      })
    },
    async getCollectionPageId () {
      try {
        // 최신 버전
        const getPageId = await this.$store.dispatch('collection/getCollectionPageId')
        const pageId = getPageId && getPageId.message && getPageId.message.pageId
        return pageId
      } catch (ex) {
        return false
      }
    },
    async getCollectionPageProperty () {
      try {
        // 최신 버전
        const getLastVersion = await this.$store.dispatch('shop/getLastVersion', this.pageId)
        const version = getLastVersion && getLastVersion.message && getLastVersion.message.last_version
        // 인덱스디비에 있는지, 최신 버전인지
        const indexedData = await this.$store.dispatch('versionhistory/getIndexedDb', {
          table: 'collection',
          id: this.pageId,
          version: version || 0
        })
        // 버전이 다르거나 인덱스디비에 없으면 샵프로퍼티 호출 아니면 인덱스 데이터 리턴
        const res = (!indexedData || indexedData === 'diffVersion')
          ? await this.$store.dispatch('shop/getOrderPageProperty', {shopPageId: this.pageId})
          : indexedData
        const property = (!indexedData || indexedData === 'diffVersion')
          ? res && res.property
          : indexedData
        const removeEmptySubCategory = (arr) => { // 서브카테고리가 비어있으면 필요없음
          return arr.map(({ subCategory, ...rest }) => {
            return subCategory && subCategory.length
              ? { ...rest, subCategory: removeEmptySubCategory(subCategory) }
              : rest
          })
        }
        if ((!indexedData || indexedData === 'diffVersion') && res && res.property) {
          this.$store.dispatch('versionhistory/setIndexedDb', {
            table: 'collection',
            id: this.pageId,
            version: res.version,
            data: res.property
          })
        }
        // 페이지 설정
        this.$store.commit('collection/setCollectionSetting', property.pageData.settings)
        // 내비게이션 설정
        this.$store.commit('collection/setCollectionNavSetting', property.naviSetting)
        // 아이템 프로퍼티
        this.$store.commit('collection/setItemProperty', property.collectionItemsProperty)
        // 카테고리
        this.$store.commit('collection/setCollectionCategory', property.categoryProperty)
        // 마이콜렉션 설정
        this.$store.commit('collection/setMyCollectionSetting', {...property.myCollectionSetting, category: removeEmptySubCategory(property.myCollectionSetting.category)})
      } catch (ex) {
        return false
      }
    },
    setToastMessage (message) {
      this.$store.commit('collection/setToastMessage', message)
    }
  }
}
</script>